import React, {Component} from 'react'
import {reduxForm, Field} from 'redux-form'
import './RegistrationMark.css'
import Captcha from "../../../components/Captcha";

class RegistrationMark extends Component {

    render() {
        return(
            <form onSubmit={this.props.handleSubmit}>
                <div className="col-md-8 col-md-push-2">
                    <div className="panel panel-default panel-border">
                        <div className="panel-body">
                            <h2 className="title">Richiedi Contrassegno</h2>
                            <p>
                                Hai diritto al: <strong>{this.props.markType.label + " - " + this.props.markType.name}</strong>.<br />
                                Puoi possedere massimo <strong>{this.props.markRule.marksLimit}</strong> contrassegn{this.props.markRule.marksLimit === 1 ? 'o' : 'i'} per famiglia/impresa.<br />
                                {this.props.markRule.privatePlaceReduction && <span>Per ottenere questo contrassegno è necessario non possedere un posto auto privato.<br /></span>}
                                Questo contrassegno può essere attivato su <strong>{this.props.markRule.vehicleLimit}</strong> veicol{this.props.markRule.vehicleLimit === 1 ? 'o' : 'i'}.
                            </p>
                            <div className="box">
                                <fiedset>
                                    <div className="titolo-categoria">
                                        <legend className="text-left">Informazioni Veicol{this.props.markRule.vehicleLimit === 1 ? 'o' : 'i'}</legend>
                                    </div>
                                    {this.props.markRule.vehicleLimit === -1 && <p>Questo contrassegno può essere usato su qualunque veicolo</p>}
                                    {[...Array(this.props.markRule.vehicleLimit)].map((x, i) => <div key={i} className="row">
                                        <div className="col-md-6 text-left">
                                            <label>Tipologia di proprietà</label>
                                            <Field name={"vehicles[" + i + "].vehiclePropertyType"} component="select" className="form-control sel1-control" required>
                                                <option value={''}>Seleziona tipo di proprietà</option>
                                                {this.props.vehicleTypes.map((item, index) => <option key={index} value={item.name}>{item.name}</option>)}
                                            </Field>
                                        </div>
                                        <div className="col-md-6 text-left">
                                            <label>Targa</label>
                                            <Field component="input" name={"vehicles[" + i + "].plateNumber"} type="text" className="resident-login" required/>
                                        </div>
                                    </div>)}
                                </fiedset>

                                <fiedset>
                                    <div className="titolo-categoria">
                                        <legend className="text-left">Autocertificazioni e Consensi</legend>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            {this.props.markRule.marksLimit > 1 && <div className="checkbox" style={{textAlign:'left'}}>
                                            <label>
                                                <Field component="input" type="checkbox" name={"marksLimitConsent"} required />
                                                Dichiaro di non essere già in possesso di più di
                                                {(this.props.markRule.marksLimit - 1 === 1) ? ' un ' : ' ' + (this.props.markRule.marksLimit - 1) + ' '}
                                                contrassegn{(this.props.markRule.marksLimit - 1 === 1) ? 'o' : 'i'}
                                            </label>
                                        </div>}
                                            {this.props.markRule.marksLimit === 1 && <div className="checkbox" style={{textAlign:'left'}}>
                                                <label>
                                                    <Field component="input" type="checkbox" name={"marksLimitConsent"} required />
                                                    Dichiaro di non essere già in possesso di un contrassegno di questa tipologia
                                                </label>
                                            </div>}
                                            {this.props.markRule.privatePlaceReduction && <div className="checkbox" style={{textAlign:'left'}}>
                                                <label>
                                                    <Field component="input" type="checkbox" name={"privatePlaceReductionConsent"} required />
                                                    Dichiaro di non possedere un posto auto privato
                                                </label>
                                            </div>}
                                            {this.props.markRule.overLimitMarksRequired && <div className="checkbox" style={{textAlign:'left'}}>
                                                <label>
                                                    <Field component="input" type="checkbox" name={"overLimitConsent"} required />
                                                    Dichiaro di essere già in possesso di 2 contrassegni
                                                </label>
                                            </div>}
                                            {this.props.markRule.employeesThreeMonthsRequired && <div className="checkbox" style={{textAlign:'left'}}>
                                                <label>
                                                    <Field component="input" type="checkbox" name={"employeesThreeMonthsConsent"} required />
                                                    Dichiaro di essere dipendente lavoratore in una delle zone del Piano da almeno 3 mesi
                                                </label>
                                            </div>}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4 col-md-offset-4" style={{marginTop: 10}}>
                                            <Field name='captcharesponse' component={Captcha}/>
                                            {this.props.formErrors && <span className="text-danger">{this.props.formErrors}</span>}
                                        </div>
                                    </div>
                                </fiedset>
                                <p>
                                    <button type="submit" className="btn btn-resident btn-lg btn-green">
                                        conferma
                                    </button>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </form>);
    }
}

export default reduxForm({
    form: 'registrationMark',
    enableReinitialize : true
})(RegistrationMark)


// WEBPACK FOOTER //
// ./src/containers/Registration/Mark/RegistrationMark.js